//type Action = (...args: any[]) => void;

export function debounce<T extends Function>(fn: T, wait?: number, immediate?: boolean): T {
  var timeout: number | undefined;

  return <any>function (this: any) {
    var context = this, args = arguments;
    var later = function () {
      timeout = undefined;
      if (!immediate) {
        fn.apply(context, args);
      }
    };
    var callNow = immediate && !timeout;
    window.clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      fn.apply(context, args);
    }
  };
}

export function px(size: number): string {
  return `${size}px`;
}

export function currentUnixTime(): number {
  return Math.floor(new Date().getTime() / 1000);
}